import { useToken } from '@cardboard-ui/react';
import { useEffect } from 'react';

type Area = 'top' | 'bottom' | 'left' | 'right';
type Style = {
  backgroundColor: string;
};

export const useSafeAreaInsetStyle = (area: Area, style: Style) => {
  const backgroundColor = useToken('colors', style.backgroundColor);

  useEffect(() => {
    const areaDiv = getElement(area);
    let previousColor: string = '';
    let previousOpacity: string = '0';

    if (areaDiv?.style) {
      previousColor = areaDiv.style.backgroundColor;
      previousOpacity = areaDiv.style.opacity;
      areaDiv.style.backgroundColor = backgroundColor;
      areaDiv.style.opacity = '1';
    }
    return () => {
      const areaDiv = getElement(area);
      if (areaDiv?.style) {
        areaDiv.style.backgroundColor = previousColor;
        areaDiv.style.opacity = previousOpacity;
      }
    };
  }, [backgroundColor]);
};

const getElement = (area: Area) => {
  return window.document.getElementById(`${area}Div`);
};

export default useSafeAreaInsetStyle;
